<style scoped>
  nav {  position: fixed; width: 100%; z-index: 10;  }
  .perfil {  padding: 5px;  background: #d03074;  }
</style>

<template>
  <nav class="navbar has-shadow  animated fadeInDown" v-if="estaLogado">
    <div class="navbar-brand">
      <span class="navbar-item cabecalho-sistema">
        <b-icon :icon="$sistema.icone()"/>
        <span>{{ $sistema.nome() }}</span>
      </span>
      <router-link class="navbar-item" to="/admin/dashboard"><b-icon icon="home"/></router-link>

      <div class="navbar-burger burger" @click="menu_ativo=!menu_ativo">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div class="navbar-menu" :class="{'is-active':menu_ativo}">

      <div class="navbar-start is-left">

        <router-link class="navbar-item" to="/admin/parametro_portal" >Parâmetros do Portal</router-link>

      </div>

      <div class="navbar-end">
        <slot name="notificacao"/>

        <div class="navbar-item has-dropdown is-hoverable">
          <div class="navbar-link">
            {{ usuarioLogado.nome }}
          </div>
          <div class="navbar-dropdown is-right">
            <a class="navbar-item" @click.prevent="sair">
              <b-icon icon="power"/> <span class="m-l">Sair</span>
            </a>
          </div>
        </div>

      </div>
    </div>

    <div v-if="emTeste" class="perfil"> Sistema em <br/> {{ $sistema.perfil() }} </div>
  </nav>
</template>

<script>
  import {mapActions} from 'vuex'

  export default {
    props: ['urlTrocaSenha'],
    data () {
      return {
        menu_ativo: false,
        isAlterarSenhaActive: false
      }
    },
    methods: {
      ...mapActions(['setAdmin']),
      sair () {
        this.setAdmin(null)
        this.$air.sair()
        this.$root.$emit('acessar')
      }
    },
    computed: {
      estaLogado () {
        return (this.$store.state.admin && this.$store.state.admin.token)
      },
      emTeste () {
        return this.$sistema.perfil() !== 'Produção'
      },
      usuarioLogado () {
        return this.$store.state.admin
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/admin/PortalCabecalhoAdmin.vue